import { useTranslation } from '@/hooks/use-translation';
import { motion } from 'motion/react';
import { LanguageSwitcher } from './LanguageSwitcher';
import { ThemeToggle } from './ThemeToggle';

export function Nav() {
  const { t } = useTranslation();

  return (
    <motion.nav
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-[#0a0f14]/80 backdrop-blur-md border-b border-slate-200 dark:border-[#1a2530]"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Logo mark */}
          <div className="w-8 h-8 relative">
            <svg viewBox="0 0 32 32" className="w-full h-full">
              <rect
                x="2"
                y="2"
                width="12"
                height="12"
                fill="none"
                className="stroke-[#5a8a9a] dark:stroke-[#7ab8c9]"
                strokeWidth="1.5"
              />
              <rect
                x="18"
                y="2"
                width="12"
                height="12"
                className="fill-[#5a8a9a] dark:fill-[#7ab8c9]"
                opacity="0.3"
              />
              <rect
                x="2"
                y="18"
                width="12"
                height="12"
                className="fill-[#5a8a9a] dark:fill-[#7ab8c9]"
                opacity="0.5"
              />
              <rect
                x="18"
                y="18"
                width="12"
                height="12"
                fill="none"
                className="stroke-[#5a8a9a] dark:stroke-[#7ab8c9]"
                strokeWidth="1.5"
              />
            </svg>
          </div>
          <span className="font-display text-slate-900 dark:text-[#e8ebe9] text-xl md:text-2xl">
            Urban Maps
          </span>
        </div>

        <div className="hidden md:flex items-center gap-8">
          <a
            href="#problem"
            className="text-slate-600 dark:text-[#8a9a9e] text-sm md:text-base font-medium hover:text-slate-900 dark:hover:text-[#e8ebe9] transition-colors duration-200"
          >
            {t('nav.context')}
          </a>
          <a
            href="#solution"
            className="text-slate-600 dark:text-[#8a9a9e] text-sm md:text-base font-medium hover:text-slate-900 dark:hover:text-[#e8ebe9] transition-colors duration-200"
          >
            {t('nav.solution')}
          </a>
          <a
            href="#users"
            className="text-slate-600 dark:text-[#8a9a9e] text-sm md:text-base font-medium hover:text-slate-900 dark:hover:text-[#e8ebe9] transition-colors duration-200"
          >
            {t('nav.users')}
          </a>
          <a
            href="#revenue"
            className="text-slate-600 dark:text-[#8a9a9e] text-sm md:text-base font-medium hover:text-slate-900 dark:hover:text-[#e8ebe9] transition-colors duration-200"
          >
            {t('nav.revenue')}
          </a>
          <a
            href="#market"
            className="text-slate-600 dark:text-[#8a9a9e] text-sm md:text-base font-medium hover:text-slate-900 dark:hover:text-[#e8ebe9] transition-colors duration-200"
          >
            {t('nav.market')}
          </a>
        </div>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          <ThemeToggle />
          <a
            href="#contact"
            className="hidden sm:block px-5 py-2.5 rounded-xl border border-slate-300 dark:border-[#3d5a6e] text-slate-800 dark:text-[#e8ebe9] text-sm md:text-base font-medium hover:bg-slate-100 dark:hover:bg-[#1a2530] transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
          >
            {t('nav.contact')}
          </a>
        </div>
      </div>
    </motion.nav>
  );
}
